import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const eocTeamGroupDetailRoute: InvariantJiraRoute = {
	name: 'eoc-team-group-detail',
	path: '/jira/ops/teams/:teamId/group-detail/:id',
	exact: true,
};
